module.exports = __webpack_public_path__ + "img/clothing30.2471c96b.jpg";